import Vue from 'vue';
import VueRouter from 'vue-router';

// const Experience = () => import(/* webpackChunkName:'experience' */ "../views/experience/experience.vue");
// const Down =
// const Login = () => import(/* webpackChunkName: "login" */ "../views/login/login.vue");
// const Identity = () => import(/*webpackChunkName:"identity" */ "../views/identity/identity.vue")
// const BindPhone = () => import(/*webpackChunkName:"bindPhone" */ "../views/bindPhone/bindPhone.vue")
// const SetName = () => import(/*webpackChunkName:"setName" */ "../views/setName/setName.vue")
// const SecondBar = () => import(/* webpackChunkName:"secondBar"*/ "../views/secondBar/secondBar.vue")

// const Me = () => import(/* webpackChunkName:"me"*/ "../views/me/me.vue")
// const Medication = () => import(/* webpackChunkName:"medication"*/ "../views/medication/medication.vue")
// const Order = () => import(/* webpackChunkName:"order"*/ "../views/order/order.vue")

// const WorkAddress = () => import(/*webpackChunkName:"workAddress" */ "../views/workAddress/workAddress")
// const HistoryAddress = () => import(/*webpackChunkName:"historyAddress" */ "../views/historyAddress/historyAddress")
// const addressDetail = () => import(/*webpackChunkName:"addressDetail" */ "../views/addressDetail/addressDetail")
// const ChooseMed = () => import(/*webpackChunkName:"chooseMed" */ "../views/chooseMed/chooseMed")
// const OrderDetail = () => import(/*webpackChunkName:"orderDetail" */ "../views/orderDetail/orderDetail")
// const FeedbackHistory = () => import(/*webpackChunkName:"feedbackHistory" */ "../views/feedbackHistory/feedbackHistory")
// const FlyHistory = () => import(/*webpackChunkName:"flyHistory" */ "../views/flyHistory/flyHistory")
// const Rate = () => import(/*webpackChunkName:"rate" */ "../views/rate/rate")
// const Rated = () => import(/*webpackChunkName:"rated" */ "../views/rated/rated")
// const Refund = () => import(/*webpackChunkName:"refund"*/ "../views/refund/refund")
import BeforeLogin from '../views/beforeLogin/beforeLogin.vue';
// import Login from '../views/login/login';
import store from '../store/index';

const routes = [
  {
    path: '/',
    name: 'beforeLogin',
    component: BeforeLogin,
    meta: { title: '呼呼打药', needLogin: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/login.vue'),
    meta: { title: '登录', needLogin: true },
  },
  {
    path: '/maps',
    name: 'maps',
    component: () => import(/*webpackChunkName:"map" */ '@/views/map/map'),
    meta: { title: '飞行轨迹' },
  },
  {
    path: '/refundDetail',
    name: 'refund_detail',
    component: () =>
      import(/*webpackChunkName:"refundDetail" */ '@/views/refundDetail/refundDetail'),
    meta: { title: '退款详情' },
  },
  {
    path: '/notFarmer',
    name: 'notFarmer',
    component: () => import(/*webpackChunkName:"map" */ '@/views/notFarmer/notFarmer'),
    meta: { title: '呼呼打药' },
  },
  {
    path: '/deal',
    name: 'deal',
    component: () => import(/*webpackChunkName:"deal" */ '@/views/deal/deal'),
    meta: { title: '用户协议' },
  },
  {
    path: '/feedbackHistory',
    name: 'feedback_history',
    component: () =>
      import(/*webpackChunkName:"feedbackHistory" */ '@/views/feedbackHistory/feedbackHistory'),
    meta: { title: '反馈历史' },
  },
  {
    path: '/refund',
    name: 'refund',
    component: () => import(/*webpackChunkName:"refund"*/ '../views/refund/refund'),
  },
  {
    path: '/flyHistory',
    name: 'fly_history',
    component: () => import(/*webpackChunkName:"flyHistory" */ '../views/flyHistory/flyHistory'),
  },
  {
    path: '/flyDataOne',
    name: 'flyDataOne',
    meta: { title: '飞行数据' },
    component: () =>
      import(/*webpackChunkName:"flyDataOne" */ '../views/fly_data_one/fly_data_one'),
  },
  {
    path: '/fly_data_two',
    name: '/fly_data_two',
    component: () =>
      import(/*webpackChunkName:"flyDataTwo" */ '../views/fly_data_two/fly_data_two'),
  },
  {
    path: '/rate',
    name: 'rate',
    component: () => import(/*webpackChunkName:"rate" */ '../views/rate/rate'),
    meta: { title: '评价' },
  },
  {
    path: '/rated',
    name: 'rated',
    component: () => import(/*webpackChunkName:"rated" */ '../views/rated/rated'),
    meta: { title: '已评价' },
  },
  {
    path: '/orderDetail',
    name: 'order_detail',
    component: () => import(/*webpackChunkName:"orderDetail" */ '../views/orderDetail/orderDetail'),
    meta: { title: '订单详情' },
  },
  {
    path: '/down',
    name: 'down',
    component: () => import(/* webpackChunkName:'down' */ '../views/down/down.vue'),
    meta: { title: '下载页' },
  },
  {
    path: '/experience',
    name: 'experience',
    component: () =>
      import(/* webpackChunkName:'experience' */ '../views/experience/experience.vue'),
  },

  {
    path: '/lookforPwd',
    name: 'lookfor_pwd',
    component: () =>
      import(/* webpackChunkName: "lookforPwd" */ '../views/lookforPwd/lookforPwd.vue'),
    meta: { title: '找回密码' },
  },
  {
    path: '/makePwd',
    name: 'make_pwd',
    component: () => import(/* webpackChunkName: "makePwd" */ '../views/makePwd/makePwd.vue'),
    meta: { title: '设置密码' },
  },
  {
    path: '/identity',
    name: 'identity',
    component: () => import(/*webpackChunkName:"identity" */ '../views/identity/identity.vue'),
    meta: { title: '选择身份' },
  },
  {
    path: '/bindPhone',
    name: 'bind-phone',
    component: () => import(/*webpackChunkName:"bindPhone" */ '../views/bindPhone/bindPhone.vue'),
    meta: { title: '绑定手机' },
  },
  {
    path: '/setName',
    name: 'set-name',
    component: () => import(/*webpackChunkName:"setName" */ '../views/setName/setName.vue'),
    meta: { title: '设置名字' },
  },
  {
    path: '/secondBar',
    component: () => import(/* webpackChunkName:"secondBar"*/ '../views/secondBar/secondBar.vue'),

    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName:"me"*/ '../views/me/me.vue'),
        meta: { name: 'me', title: '呼呼打药', needUserType: true },
      },
      {
        path: 'me',
        component: () => import(/* webpackChunkName:"me"*/ '../views/me/me.vue'),
        meta: { name: 'me', title: '呼呼打药', needUserType: true },
      },
      {
        path: 'medication',
        component: () =>
          import(/* webpackChunkName:"medication"*/ '../views/medication/medication.vue'),
        meta: { name: 'medication', title: '呼呼打药', needUserType: true },
      },
      {
        path: 'order',
        component: () => import(/* webpackChunkName:"order"*/ '../views/order/order.vue'),
        meta: { name: 'order', title: '订单列表', needUserType: true },
      },
    ],
  },
  {
    path: '/workAddress',
    name: 'work_address',
    component: () => import(/*webpackChunkName:"workAddress" */ '../views/workAddress/workAddress'),
    meta: { title: '作业地址' },
  },
  {
    path: '/historyAddress',
    name: 'history_address',
    component: () =>
      import(/*webpackChunkName:"historyAddress" */ '../views/historyAddress/historyAddress'),
    meta: { title: '历史作业地址' },
  },
  {
    path: '/addressDetail',
    name: 'addressDetail',
    component: () =>
      import(/*webpackChunkName:"addressDetail" */ '../views/addressDetail/addressDetail'),
    meta: { title: '作业地址详情' },
  },
  {
    path: '/chooseMed',
    name: 'Choose_med',
    component: () => import(/*webpackChunkName:"chooseMed" */ '../views/chooseMed/chooseMed'),
    meta: { title: '选择商品' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  console.log('to', to);
  console.log('from', from);

  console.log('store.state.token', store.state.token);
  // console.log('store.state.userType', store.state.userType);
  console.log('store.state.token', !!store.state.token);
  if (store.state.userType != 1 && to.meta.needUserType) {
    console.log('用户类型不等于1----------');
    next('/notFarmer');
  } else {
    next();
  }
  // if (!!store.state.token && !to.meta.needLogin) {
  //   console.log('缺少token----------');
  //   next('/');
  // } else {
  //   console.log('正常跳转');
  //   console.log('to.meta.needUserType', to.meta.needUserType);
  //   if (store.state.userType != 1 && to.meta.needUserType) {
  //     console.log('用户类型不等于1----------');
  //     next('/notFarmer');
  //   } else {
  //     next();
  //   }
  // }
});
// router.beforeResolve((to, from, next) => {
//   if (!store.state.token && to.path != '/') {
//     console.log('缺少token----------');
//     next('/');
//   } else if (store.state.userType != 1 && to.meta.needUserType && store.state.token) {
//     console.log('用户类型不等于1----------');
//     next('/notFarmer');
//   } else {
//     console.log('正常跳转');
//     next();
//   }
// });
router.afterEach((to) => {
  window.scrollTo(0, 0);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

Vue.use(VueRouter);
export default router;
